import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { AlertTriangle, Menu, X, MessageSquare, Building2 } from 'lucide-react';
import Section from '@@/components/Sidebar/Section';
import Footer from '@@/components/Sidebar/Footer';

const Sidebar: React.FC = () => {
  const [isMobileOpen, setIsMobileOpen] = useState(false);

  const toggleMobileSidebar = () => {
    setIsMobileOpen(!isMobileOpen);
  };

  const closeMobileSidebar = () => {
    setIsMobileOpen(false);
  };

  return (
    <>
      {/* Bouton menu mobile (visible uniquement sur mobile) */}
      <button
        onClick={toggleMobileSidebar}
        className="lg:hidden fixed top-4 left-4 z-50 p-2 bg-white rounded-lg shadow-lg border border-neutral-200 transition-colors hover:bg-neutral-50"
      >
        <Menu size={24} className="text-neutral-600" />
      </button>

      {/* Sidebar principale */}
      <div
        className={`
        w-64 bg-white shadow-lg border-r border-neutral-200 fixed left-0 top-0 h-screen z-30 transform transition-transform duration-300 ease-in-out
        lg:translate-x-0
        ${isMobileOpen ? 'translate-x-0' : '-translate-x-full'}
      `}
      >
        <div className="flex flex-col h-full">
          {/* Header avec logo et bouton fermer mobile */}
          <div className="p-6 border-b border-neutral-200 flex-shrink-0">
            <div className="flex items-center justify-between">
              <Link to="/" className="" onClick={closeMobileSidebar}>
                <img alt="Alacaza" src="/logo.svg" className="w-full" />
              </Link>

              {/* Bouton fermer (visible uniquement sur mobile) */}
              <button
                onClick={closeMobileSidebar}
                className="lg:hidden p-2 hover:bg-neutral-100 rounded-lg transition-colors"
              >
                <X size={20} className="text-neutral-600" />
              </button>
            </div>
          </div>

          {/* Navigation principale - scrollable si nécessaire */}
          <div className="flex-1 py-6 space-y-2 overflow-y-auto">
            <div className="px-4 mb-4">
              <h3 className="text-body-xs font-semibold text-neutral-500 uppercase tracking-wider">
                Navigation
              </h3>
            </div>

            <div onClick={closeMobileSidebar}>
              <Section Icon={Building2} title="Mon parc" to="/properties" />
              <Section
                Icon={MessageSquare}
                title="Communications"
                to="/messages"
              />
              <Section Icon={AlertTriangle} title="Incidents" to="/incidents" />
            </div>
          </div>

          {/* Footer - toujours visible en bas */}
          <div className="border-t border-neutral-200 flex-shrink-0">
            <Footer />
          </div>
        </div>
      </div>

      {/* Spacer pour le contenu principal (visible uniquement sur desktop) */}
      <div className="hidden lg:block w-64 flex-shrink-0"></div>
    </>
  );
};

export default Sidebar;
